// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1J7K2","options":"AnswerScale_options__2tClq","selected":"AnswerScale_selected__2p4yG"};